import axios from '../utils/axios';

export default function getSeekerLogsSubs(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/getseekerlogssubs`, { params });
};